import styled from 'styled-components';
import Page from './Page';
import { withGutters } from './withGutters';

const PageWithGutters = styled(Page)`
  display: flex;
  flex-direction: column;
`;

export default withGutters(PageWithGutters);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/containers/PageWithGutters.tsx